import { useUser } from "@app/store/userStore";
import { Chip, type ChipProps } from "@design-system/Inputs/Chip";
import { type FC, type Ref } from "react";

type UserTagProps = ChipProps & {
    userId: string | undefined | null;
    noUserText?: string;
    className?: string;
    displayFullName?: boolean;
    size?: "sm" | "md";
    isTrigger?: boolean;
    disabled?: boolean;
    ref?: Ref<HTMLButtonElement>;
};

export const UserTag: FC<UserTagProps> = ({
    userId,
    noUserText,
    className,
    displayFullName = true,
    size = "sm",
    isTrigger = false,
    disabled = false,
    ref,
    ...props
}) => {
    const user = useUser(userId ?? undefined);
    const nameToDisplay = `${user?.firstName} ${displayFullName ? user?.lastName : user?.lastName?.slice(0, 1)}${displayFullName ? "" : "."}`;

    return (
        <Chip
            className={className}
            size={size}
            interactive={isTrigger}
            disabled={disabled}
            ref={ref}
            {...props}
        >
            <Chip.Avatar
                size={size}
                hexColor={!user ? "#FFFFFF" : undefined}
                letter={user?.firstName?.[0]}
                imageUrl={user?.avatar?.signedUrl}
            />

            {user && <Chip.Value>{nameToDisplay}</Chip.Value>}
            {!user && noUserText && <Chip.Value>{noUserText}</Chip.Value>}
            {isTrigger && <Chip.Icon name="chevronDown" />}
        </Chip>
    );
};
